<template>
    <iframe
        :src="videoUrl"
    ></iframe>
</template>

<script>
import UrlParse from 'url-parse'

export default {
  components: {
  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    videoUrl () {
      const url = UrlParse(this.src, true)
      console.log(url)
      let id = ''
      if (url.hostname.indexOf('youtu.be') >= 0) {
        // https://youtu.be/pFIjiUOyOGo
        id = url.pathname.split('/')
        console.log(id)
        if (id.length > 1) id = id[1]
      } else {
        id = url.query ? url.query.v || '' : ''
      }
      return 'https://www.youtube.com/embed/' + id
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus">
// @import '../../assets/css/base.styl'
</style>



// WEBPACK FOOTER //
// src/components/commons/videos/YoutubeVideo.vue